import {CREATE_TRANSFER_ATM} from '../actions/index';

export default function (state = null, action) {
  switch (action.type) {
    case CREATE_TRANSFER_ATM:
      return action.payload.data;
    default:
      break;
  }
  return state;
}
